import { deflateSync, inflateSync, strFromU8, strToU8 } from "fflate";
import { parseTheme, type Theme } from "@/model/theme";

const PREFIX = "s=";

function toBase64Url(bytes: Uint8Array): string {
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function fromBase64Url(text: string): Uint8Array {
  const b64 = text.replace(/-/g, "+").replace(/_/g, "/");
  const bin = atob(b64 + "=".repeat((4 - (b64.length % 4)) % 4));
  return Uint8Array.from(bin, (c) => c.charCodeAt(0));
}

/** `#s=<deflate+base64url>`: the whole theme lives in the URL, no server involved. */
export function encodeShare(theme: Theme): string {
  const { id: _id, locks: _locks, ...rest } = theme;
  return PREFIX + toBase64Url(deflateSync(strToU8(JSON.stringify(rest)), { level: 9 }));
}

export function decodeShare(hash: string): Theme | null {
  const body = hash.replace(/^#/, "");
  if (!body.startsWith(PREFIX)) return null;
  const json = strFromU8(inflateSync(fromBase64Url(body.slice(PREFIX.length))));
  return parseTheme(JSON.parse(json));
}

export function shareUrl(
  theme: Theme,
  origin = globalThis.location?.origin ?? "https://themes.utimura.io",
): string {
  return `${origin}/#${encodeShare(theme)}`;
}
